import CloseIcon from "@mui/icons-material/Close";
import { Dialog as MuiDialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { type ReactNode } from "react";

export interface DialogProps {
  actions: ReactNode;
  dialogType: "custom" | "confirm" | "info";
  /** When true, focus is not trapped in the dialog. Use for content that portals outside the dialog (e.g. MUI X pickers). */
  disableEnforceFocus?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  onDialogClose: () => void;
  open: boolean;
  title: string;
  titleSx?: Record<string, unknown>;
}

export const Dialog = (props: DialogProps) => {
  const {
    actions,
    dialogType,
    disableEnforceFocus = false,
    maxWidth = "md",
    onDialogClose,
    open,
    title,
    titleSx,
  } = props;

  return (
    <MuiDialog
      aria-labelledby="dialog-title"
      disableEnforceFocus={disableEnforceFocus}
      fullWidth
      maxWidth={maxWidth}
      onClose={onDialogClose}
      open={open}
    >
      <DialogTitle id="dialog-title" sx={{ m: 0, p: 2, ...titleSx }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onDialogClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>{dialogType === "custom" && actions}</DialogContent>
      {dialogType !== "custom" && <DialogActions>{actions}</DialogActions>}
    </MuiDialog>
  );
};

export default Dialog;
